import store from './state/store';

export const getCurrentDate = () => {
  const currentDateString = store.getState().settingsReducer.currentDate;
  const currentDate = new Date(currentDateString + 'T00:00:00');
  if (window.DEBUG) console.log('CurrentDate: ' + currentDate);
  return currentDate;
};

export const getCurrentDateMs = () => {
  const currentDateString = store.getState().settingsReducer.currentDate;
  const currentDateMs = new Date(currentDateString + 'T00:00:00').getTime();
  if (window.DEBUG) console.log('CurrentDateMs: ' + currentDateMs);
  return currentDateMs;
};
